module.exports = __webpack_public_path__ + "static/img/bg5.12fd2bea.png";